export enum UploadObjectType {
  JOB = 'job',
  REPOSITORY = 'repository',
}
